import { HeartIcon, IconFillColor, IconSize } from '@dreryk/react-components';

import { StyledFavouriteMedicinesSelectorNoResultsIconWrapper } from './FavoriteMedicinesSelectorNoResultsIconWrapper.styled';

export const FavoriteMedicinesSelectorNoResultsHeartIcon = (): JSX.Element => {
   return (
      <StyledFavouriteMedicinesSelectorNoResultsIconWrapper
         testId={'noFavouriteMedicines'}
         size={IconSize.SMALL}
         fillColor={IconFillColor.CURRENT_COLOR}
      >
         <HeartIcon />
      </StyledFavouriteMedicinesSelectorNoResultsIconWrapper>
   );
};
